import * as Nav from "../../../assets/app_js/layout/nav.js";

document.addEventListener("trainingSession:mounted", (event) => {
  const trainingSessionId = event.detail.training_session_id;
  const titleEl = event.detail.title_page;

  if (trainingSessionId && titleEl) {
    Nav.pushActiveSession({ id: trainingSessionId, name: titleEl });
  }
});
